import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ provider }) => {
  return {
    fetchCompanies: {
      [SERVICE_PROVIDERS.EDVIR]: () => true,
      default: () => false,
    },
    dutyStatusRenderComponent_formElements: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    malFunctionReportRenderComponent_message: {
      [SERVICE_PROVIDERS.RADIUS]: () => true,
      [SERVICE_PROVIDERS.NAUTO]: () => true,
      [SERVICE_PROVIDERS.BRIGHT_ORDER]: () => true,

      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
